import { BiEdit } from 'react-icons/bi';
import { color } from '../color';
import { ImCheckmark } from 'react-icons/im';
import { Icon } from '../icon';
import { RiDeleteBin6Line, RiTimeLine } from 'react-icons/ri';
import React from 'react';

export const WARRANTY_STATUS = [
  { key: 'ACTIVE', label: 'ACTIVE', icon: <BiEdit />, iconColor: color.blue_why },
  { key: 'CLAIMING', label: 'CLAIMING', icon: <ImCheckmark />, iconColor: color.yellow },
  { key: 'COMPLETED', label: 'COMPLETED', icon: <Icon.Box />, iconColor: color.submit },
  { key: 'EXPIRED', label: 'EXPIRED', icon: <RiTimeLine />, iconColor: '#9e9e9e' },
  { key: 'CANCEL', label: 'CANCEL', icon: <RiDeleteBin6Line />, iconColor: '#ff5e5e' },
];

export const CLAIM_STATUS = [
  { key: 'WAIT', label: 'รอการตรวจสอบ', iconColor: color.blue_why, icon: <Icon.Hourglass /> },
  {
    key: 'PREPARING',
    label: 'กำลังเตรียมจัดส่ง',
    iconColor: color.yellow,
    icon: <Icon.Truck />,
  },
  {
    key: 'TRANSPORTED',
    label: 'จัดส่งเรียบร้อย',
    iconColor: color.line,
    icon: <Icon.PaperPlane />,
  },
  { key: 'REJECTED', label: 'ไม่อนุมัติ', iconColor: color.red, icon: <Icon.Times /> },
  { key: 'CANCEL', label: 'ยกเลิกรายการ', iconColor: color.gray, icon: <Icon.Cancel /> },
];

export const PROCESS_STATUS = [
  { key: 'WAITING_REVIEW', label: 'รอตรวจสอบแจ้งเคลม', color: color.blue_why },
  { key: 'WAITING_CHECK_LACK_ITEM', label: 'รอตรวจสอบ ของขาด', color: color.yellow },
  { key: 'INCOMPLETE_INFO', label: 'รอตรวจสอบ รูปไม่ถูกต้อง', color: color.yellow },
  { key: 'WAIT_CONTACT_CUSTOMER', label: 'รอติดต่อลูกค้า', color: color.red },
  { key: 'PREPARING_SEND', label: 'กำลังเตรียมพัสดุ', color: color.yellow },
  { key: 'SHIPPED', label: 'จัดส่งเรียบร้อย', color: color.line },
  { key: 'REJECT', label: 'ไม่อนุมัติ', color: color.red },
  { key: 'CANCEL', label: 'ยกเลิกเคลม', color: color.gray },
];

export const STORE_STATUS = [
  { key: 'ACTIVE', label: 'ACTIVE' },
  { key: 'INACTIVE', label: 'INACTIVE' },
];
export const ALLOW_WARRANTY_STATUS = [
  { key: 'ACTIVE', label: 'เปิดใช้งาน', color: color.line },
  { key: 'INACTIVE', label: 'ปิดใช้งาน', color: color.red },
];
export const ALLOW_CLIAM_STATUS = [
  { key: 'ACTIVE', label: 'เปิดใช้งาน', color: color.line },
  { key: 'INACTIVE', label: 'ปิดใช้งาน', color: color.red },
];
export const PRODUCT_STATUS = [
  { key: 'ACTIVE', label: 'เปิดใช้งาน', color: color.line },
  { key: 'INACTIVE', label: 'ปิดใช้งาน', color: color.red },
];

export const ALLOW_WARRANTY_NUMBER_REQUIRED_STATUS = [
  { key: true, label: 'บังคับ', color: color.line },
  { key: false, label: 'ไม่บังคับ', color: color.red },
];
export const GENERATE_STATUS = [
  { key: 'WAIT_GEN', label: 'รอ GEN QR' },
  { key: 'CREATING', label: 'กำลัง GEN QR' },
  { key: 'COMPLETED', label: 'สำเร็จ' },
  { key: 'CREATE_FAILED', label: 'ล้มเหลว' },
  { key: 'SEND_FAILED', label: 'ส่งอีเมลล้มเหลว' },
];
